<script>
    import {isEditingName} from '../workspacesStore.js';

    export let row = null;
    export let col = '';
    export let save = () => {};
    export let editable = false;
    export let style = '';

    let name = '';
    let input = null;
    let saved = false;
    let isEditMode = false;

    $: if (editable && input) {
        input.focus();
        saved = false;
    }

    function onKeyUp(event) {
        if (event.key === 'Enter') {
            handleSave();
        }
    }

    function handleSave() {
        saved = true;
        if (name) {
            row[col] = name;
        }
        save(row);
        isEditMode = false;
        isEditingName.set(isEditMode);
    }

    function onDoubleClick(event) {
        if (editable) {
            isEditMode = true;
            isEditingName.set(isEditMode);
            name = row[col];
        }
    }

    function onBlur() {
        if (!saved) {
            handleSave();
        }
    }
</script>

<style>
    input[type="text"] {
        width: 100%;
        line-height: normal;
    }

    .name-input {
        flex: 1;
    }

    .invalid {
        margin-left: 2px;
    }
</style>

{#if !isEditMode}
    <span
            class="name font-weight-bold"
            on:dblclick={onDoubleClick}
    >
    {row[col]}
</span>
{:else}
    <span class="name-input invalid">
    <input
            type="text"
            bind:this={input}
            on:keyup={onKeyUp}
            on:blur={onBlur}
            bind:value={name}
            style={style}/>
</span>
{/if}
